const ALLOWED_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/svg+xml'];
const MAX_BYTES = 2 * 1024 * 1024;

export function validateCmsEditorImageFile(file) {
  if (!file) {
    return 'No file selected';
  }
  if (!ALLOWED_TYPES.includes(file.type)) {
    return 'Only image files are allowed (jpeg, jpg, png, gif, svg)';
  }
  if (file.size > MAX_BYTES) {
    return 'Image size must be less than 2MB';
  }
  return null;
}

/**
 * Attach S3 upload to CKEditor's built-in image dialog (onReady only — do not use extraPlugins).
 */
export function attachCmsUploadAdapter(editor, uploadFn) {
  if (!editor || !uploadFn) {
    return;
  }
  try {
    const fileRepository = editor.plugins.get('FileRepository');
    fileRepository.createUploadAdapter = (loader) => ({
      upload: () =>
        loader.file
          .then((file) => {
            const validationError = validateCmsEditorImageFile(file);
            if (validationError) {
              return Promise.reject(validationError);
            }
            return uploadFn(file);
          })
          .then((url) => ({ default: url })),
      abort: () => {}
    });
  } catch (error) {
    console.warn('CMS editor: FileRepository not available for image upload.', error);
  }
}
